import { OMS_RECYCLE_ORDER_TYPE_MAP } from 'commons/options';

/** 法国回收/寄卖单供应商类型 */
export enum SupplierType {
  COMPANY = 'COMPANY',
  INDIVIDUAL = 'INDIVIDUAL',
}

/**
 * 订单税制快照（含出口）
 * - STANDARD_TVA / MARGIN：同商品
 * - EXPORT_AIRPORT：仅 STANDARD 商品且收货地非 EU
 */
export enum TaxRegime {
  STANDARD_TVA = 'STANDARD_TVA',
  MARGIN = 'MARGIN',
  EXPORT_AIRPORT = 'EXPORT_AIRPORT',
}

/**
 * 商品侧可用税制（不含出口覆盖）
 * - STANDARD_TVA：标准 TVA
 * - MARGIN：差额税
 */
export enum ProductTaxRegime {
  STANDARD_TVA = 'STANDARD_TVA',
  MARGIN = 'MARGIN',
}

/**
 * 顾客侧（C 端 / 小票 / invoice）是否展示税额。
 * MARGIN 税额仍落库供报表，但对用户隐藏。
 */
export function shouldDisplayFranceTaxToCustomer(
  taxRegime?: TaxRegime | string | null,
): boolean {
  return taxRegime !== TaxRegime.MARGIN;
}

/** 回收 + 法人：进项可能是标准 VAT 或 Margin，需手动选择销项税制 */
export function needsManualTaxRegimeSelection(
  orderType: number,
  supplierType?: SupplierType | null,
): boolean {
  return (
    orderType === OMS_RECYCLE_ORDER_TYPE_MAP.RECYCLE &&
    supplierType === SupplierType.COMPANY
  );
}

/**
 * 按合同类型 + 供应商类型推导商品税制
 * - 寄卖 → STANDARD_TVA
 * - 回收 + 个人 → MARGIN
 * - 回收 + 法人 → undefined（需手动选择 STANDARD_TVA / MARGIN）
 * - 回收但未选供应商类型 → undefined
 */
export function resolveProductTaxRegime(
  orderType: number,
  supplierType?: SupplierType | null,
): ProductTaxRegime | undefined {
  if (orderType === OMS_RECYCLE_ORDER_TYPE_MAP.CONSIGNMENT) {
    return ProductTaxRegime.STANDARD_TVA;
  }

  if (orderType === OMS_RECYCLE_ORDER_TYPE_MAP.RECYCLE) {
    if (supplierType === SupplierType.INDIVIDUAL) {
      return ProductTaxRegime.MARGIN;
    }
    // 回收 + 法人：不自动判定，由建单页手动选择
  }

  return undefined;
}
